import { Button } from '@retainerclub/common';
import PropTypes from 'prop-types';

function RetentionOffers({
  retentionOffers,
  handleRetentionOffer,
  isLoading,
  display,
}) {
  return display ? (
    <div className="space-y-4">
      {retentionOffers.map((offer) => (
        <div key={offer.id} className="rounded-lg border border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="font-medium text-gray-900">{offer.description}</h4>
              <p className="text-gray-600 text-sm">Limited time offer</p>
            </div>
            <Button
              name="Accept Offer"
              size="sm"
              color="green"
              rounded
              onClick={() => handleRetentionOffer(offer)}
              disabled={isLoading}
            />
          </div>
        </div>
      ))}
    </div>
  ) : null;
}

RetentionOffers.propTypes = {
  retentionOffers: PropTypes.array.isRequired,
  handleRetentionOffer: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  display: PropTypes.bool.isRequired,
};

export default RetentionOffers;
